import React from "react";

function ComposeIcon() {
  return (
    <div>
      <svg
        fill="white"
        height="22px"
        width="22px"
        viewBox="0 0 1920 1920"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        <g
          id="SVGRepo_tracerCarrier"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></g>
        <g id="SVGRepo_iconCarrier">
          {" "}
          <path
            d="M909.191 303.66v101.02h-808.17v1414.3H1515.32v-721.494h101.021V1920H0V303.66h909.191ZM1562.132 0c40.51 0 78.494 15.76 106.982 44.348l206.588 206.488c58.997 59.097 58.997 155.27 0 214.266L1666.184 674.62l-349.432-349.332-818.778 818.778 277.91 277.91 723.514-723.414 71.422 71.422-857.367 857.266-526.018 105.164 105.264-525.917L1454.848 44.348C1483.437 15.76 1521.522 0 1562.03 0ZM426.552 1215.488l-40.711 40.812-69.503 347.413 347.412-69.503 40.712-40.813-277.91-277.91Zm884.007-677.469 71.422 71.422-624.716 624.716-71.422-71.422 624.716-624.716Zm251.573-436.998h-.1c-13.538 0-26.165 5.253-35.762 14.75l-138.096 138.095 278.01 277.91L1804.28 393.68c19.598-19.7 19.598-51.723 0-71.523L1597.692 115.77c-9.597-9.597-22.225-14.749-35.56-14.749Z"
            fillRule="evenodd"
          ></path>{" "}
        </g>
      </svg>
    </div>
  );
}

export default ComposeIcon;
